import type { FC, ReactNode } from "react";

import { PopupHoverContainer } from "@similarweb/ui-components";

import { AppTooltipContent } from "./AppTooltipContent";

/**
 * a Tooltip that that shows an app description
 */

interface IAppTooltipProps {
    app?: any;
    appId?: string;
    store?: string;
    hideMonthlyDownloads?: boolean;
    getAssetsUrl?: any;
    enabled?: boolean;
    placement?: string;
    debounce?: number;
    appendTo?: string;
    children?: ReactNode;
}

export const AppTooltip: FC<IAppTooltipProps> = ({
    app,
    appId,
    store,
    hideMonthlyDownloads = false,
    getAssetsUrl,
    debounce,
    appendTo,
    enabled = true,
    placement = "top-left",
    children,
}) => {
    return (
        <PopupHoverContainer
            content={() => (
                <AppTooltipContent
                    app={app}
                    appId={appId}
                    store={store}
                    hideMonthlyDownloads={hideMonthlyDownloads}
                />
            )}
            config={{
                enabled,
                placement,
                cssClassContent: "Popup-content-infoCard",
                cssClassContainer: "Popup-Container-infoCard",
                width: 394,
                height: 204,
                allowHover: true,
                closeDelay: 50,
            }}
            debounce={debounce}
            appendTo={appendTo}
        >
            {children}
        </PopupHoverContainer>
    );
};
